<template>
  <div class="misc-wrapper">
    <b-link style="position: absolute; top:0; left: 0; max-width: 200px" to="dashboard">
      <img src="@/assets/images/logo/logo.png" alt="" class="logo w-100">
    </b-link> 

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1 text-light">
          You are not authorized! 🔐
        </h2>
        <p class="mb-2">
          You don’t have permission to access this page. Go Home!!
        </p>
        <b-button
          variant="primary"
          class="mb-1 btn-sm-block rounded-pill"
          @click="loginRoute()"
        >Back to Login</b-button>
        <!-- <b-img
          fluid
          :src="imgUrl"
          alt="Not authorized page"
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg, BButton } from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

export default {
  components: {
    BLink, BImg, BButton, VuexyLogo,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/not-authorized.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: {
    loginRoute() {
      // const user = JSON.parse(localStorage.getItem('userData'))
      // return getHomeRouteForLoggedInUser(user ? user.role : null)
      this.deleteAllCookies()
      this.$router.push({name:'auth-login'})
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
.misc-wrapper{
  background: url('../../../assets/images/banner/dark_bakground.png') no-repeat;
  background-size: cover;
}
</style>
